import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { LoginService } from './landing-page/login/login.service';
import { InfoIconService } from '@vfde-fe/ngx-lib/components/info-icon';

/** APP_PROVIDERS */
export const APP_PROVIDERS = [
    CustomErrorHandlerService,
    LoginService,
    InfoIconService,
];
